import { trackEvent } from '../../../utils/analytics';

export default function BinaryChoice() {
  const scrollToCalendar = () => {
    trackEvent('calendar_click');
    const element = document.getElementById('calendar');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="contact" className="py-12 md:py-20 bg-[#121212]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-black text-center mb-8 sm:mb-10 tracking-tight">
          YOUR MOVE.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-6xl mx-auto">
          {/* Left Card - Leave It Exposed */}
          <div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-6 sm:p-8 md:p-10 hover:opacity-100 transition-opacity">
            <div className="flex items-center gap-3 mb-6">
              <i className="ri-close-circle-line text-2xl sm:text-3xl text-gray-400"></i>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-black text-gray-200">
                Leave It Exposed
              </h3>
            </div>

            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-close-line text-gray-400 text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-gray-300 text-sm md:text-base">No entity structure in place</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-close-line text-gray-400 text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-gray-300 text-sm md:text-base">Overpaying taxes without a plan</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-close-line text-gray-400 text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-gray-300 text-sm md:text-base">Estate goes to probate by default</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-close-line text-gray-400 text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-gray-300 text-sm md:text-base">Personal assets exposed to business liability</span>
              </li>
            </ul>
          </div>

          {/* Right Card - Deploy the Trifecta */}
          <div className="bg-gradient-to-br from-[#dc2626] to-[#991b1b] border-2 border-[#dc2626] rounded-xl p-6 sm:p-8 md:p-10 relative shadow-2xl shadow-[#dc2626]/20">
            <div className="absolute -top-4 right-6 bg-[#f59e0b] text-black px-4 py-1.5 rounded-full text-xs font-black tracking-wider whitespace-nowrap">
              RECOMMENDED
            </div>

            <div className="flex items-center gap-3 mb-6">
              <i className="ri-shield-check-line text-2xl sm:text-3xl text-white flex-shrink-0"></i>
              <h3 className="text-xl sm:text-2xl md:text-3xl font-black text-white">
                Deploy the Trifecta
              </h3>
            </div>

            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-white text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-white text-sm md:text-base">Entity structure that separates and protects</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-white text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-white text-sm md:text-base">Tax strategy that keeps more in your War Chest</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-white text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-white text-sm md:text-base">Estate plan that bypasses probate entirely</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-white text-xl mt-0.5 flex-shrink-0"></i>
                <span className="text-white text-sm md:text-base">One firm, one plan, total coordination</span>
              </li>
            </ul>

            <button
              onClick={scrollToCalendar}
              className="w-full py-4 bg-white text-[#dc2626] font-black text-base sm:text-lg rounded-lg hover:bg-gray-100 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap"
            >
              GET STARTED NOW
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
